import React from 'react';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { getParametersFromUrl } from '../utils/url-utils/urlUtils';

export class TrackVisitFromCampaign extends React.Component<{}> {
  /* eslint-disable camelcase */
  componentDidMount() {
    const {
      sourcePage,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_content,
    } = getParametersFromUrl(window.location.search);
    if (sourcePage === 'Campaign') {
      doctrineAnalytics('VisitFromCampaign', {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
      });
    }
  }

  render() {
    return null;
  }
}
